import { render } from "./NavigationListItem.vue?vue&type=template&id=63a3b312"
import script from "./NavigationListItem.vue?vue&type=script&lang=js"
export * from "./NavigationListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__